





import React from 'react'
import './CoachingSuccess.css'





const CoachingSuccess:React.FC = () => {
  return (
    <>
    <div className="w-screen overflow-hidden p-4 min-h-screen custom-coaching-success-container ">
        <div className="flex justify-center items-center font-sans mb-4">
            <div className=' sm:text-lg md:text-lg lg:text-3xl xl:text-3xl '>
              <h3> Thank you! Your application was submitted. Our Team will contact you</h3></div>

        </div>
    </div>
    
    
    </>
  )
}

export default CoachingSuccess
